import { render, staticRenderFns } from "./helpPanel.vue?vue&type=template&id=54a9f8e5"
import script from "./helpPanel.vue?vue&type=script&lang=ts"
export * from "./helpPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports